import { pathHomePage, applications } from "./constants";
// Assets
import clinicActiveImg from "../assets/icons/ico_clinic_gray.svg";
import clinicAvailableImg from "../assets/icons/ico_clinic.svg";
import clinicDisabledImg from "../assets/icons/ico_clinic_disabled.svg";
import appActiveImg from "../assets/icons/ico_app_gray.svg";
import appAvailableImg from "../assets/icons/ico_app.svg";
import appDisabledImg from "../assets/icons/ico_app_disabled.svg";
import wearActiveImg from "../assets/icons/ico_wear_gray.svg";
import wearAvailableImg from "../assets/icons/ico_wear.svg";
import wearDisabledImg from "../assets/icons/ico_wear_disabled.svg";
import icuActiveImg from "../assets/icons/ico_icu_gray.svg";
import icuAvailableImg from "../assets/icons/ico_icu.svg";
import icuDisabledImg from "../assets/icons/ico_icu_disabled.svg";
import plusActiveImg from "../assets/icons/ico_plus_gray.svg";
import plusAvailableImg from "../assets/icons/ico_plus.svg";
import plusDisabledImg from "../assets/icons/ico_plus_disabled.svg";

// Combined applications
export const isClinicOrHome = (software) => software === applications.clinic.name;
export const isAppOrPlus = (software) => software === applications.app.name || software === applications.plus.name;
// Separate applications
export const isApp = (software) => software === applications.app.name;
export const isPlus = (software) => software === applications.plus.name;

// Other validations
export const allowGlobalAdherenceView = (hospitalApplications) => {
  const requiredApplications = [applications.clinic.id, applications.app.id, applications.plus.id];
  return requiredApplications.some((applicationId) => hospitalApplications.includes(applicationId));
};

export const getApplicationPath = (applicationId, clinicianToken, patientId) => {
  const applicationIds = {
    [applications.clinic.id]: applications.clinic.name,
    [applications.app.id]: applications.app.name,
    [applications.wear.id]: applications.wear.name,
    [applications.icu.id]: applications.icu.name,
    [applications.plus.id]: applications.plus.name,
  };
  return `${pathHomePage}/prescriptions/${applicationIds[applicationId]}/${clinicianToken}/${patientId}`;
};

export const applicationsData = {
  [applications.clinic.id]: {
    title: "applications_clinic",
    activeImg: clinicActiveImg,
    availableImg: clinicAvailableImg,
    disableImg: clinicDisabledImg,
  },
  [applications.app.id]: {
    title: "applications_app",
    activeImg: appActiveImg,
    availableImg: appAvailableImg,
    disableImg: appDisabledImg,
  },
  [applications.wear.id]: {
    title: "applications_wear",
    activeImg: wearActiveImg,
    availableImg: wearAvailableImg,
    disableImg: wearDisabledImg,
  },
  [applications.icu.id]: {
    title: "applications_icu",
    activeImg: icuActiveImg,
    availableImg: icuAvailableImg,
    disableImg: icuDisabledImg,
  },
  [applications.plus.id]: {
    title: "applications_plus",
    activeImg: plusActiveImg,
    availableImg: plusAvailableImg,
    disableImg: plusDisabledImg,
  },
};
